export default __webpack_public_path__ + "static/media/480_dummy2016-heimtier01-de-mobile.2cbc3034.png";